<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :module-enabler="moduleEnabler"
    :inputs="inputs"
    :is-form-fetched="isFormFetched"
    @save="saveCard"
  >
    <template #documentationFeatureCard.input>
      <draggable-lists-manage-card
        left-title="admin.featureCardDocumentation"
        :layer-id="documentationLayerId"
        :has-edit-attributes="true"
      />
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
import DraggableListsManageCard from '@/components/DraggableListsManageCard';
export default {
  name: 'DocumentationSettings',
  components: { AdminWrapper, DraggableListsManageCard },
  computed: {
    additionalModuleName: get('admin/additionalModules@DOCUMENTATION.verbose_name'),
    currentLayerSchema: get('layers/currentLayerSchema'),
    documentationDataSourceName: get('admin/modulesMapping@documentation.attachment_datasource_name'),
    documentationLayerId: get('admin/modulesMapping@documentation.documentation_layer_id'),
    isModuleEnabled: get('admin/settingsValues@documentation_module_enabled'),
    moduleEnabler() {
      return {
        name: 'documentation_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    inputs() {
      return [
        {
          name: 'documentationFeatureCard',
          translationPath: 'admin.featureCardDocumentation',
          isCustom: true,
          subtitle: this.$i18n.t('admin.setDocumentationFeatureCard'),
          align: 'start',
        },
      ];
    },
  },
  data: () => ({
    isFormFetched: false,
  }),
  methods: {
    editLayer: call('layers/editLayer'),
    getDataSourceForm: call('layers/getDataSourceForm'),
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    getLayerMetadata: call('layers/getLayerMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    async init() {
      await this.getModulesMapping();
      await Promise.all([
        this.getDataSourceForm(this.documentationDataSourceName),
        this.getFeaturesLayer(this.documentationLayerId),
        this.getLayerMetadata({ dataSource: this.documentationDataSourceName }),
      ]);
      this.isFormFetched = true;
    },
    async saveCard() {
      await this.editLayer({
        layer_type: 'features_layers',
        layer_id: this.documentationLayerId,
        body: {
          form_schema: {
            elements: this.currentLayerSchema,
          },
        },
      });
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
